import { API_URL } from '../config';
import { store } from '../store/store';
import { refreshAccessToken, logoutUser } from '../store/authSlice';

/**
 * Authenticated fetch wrapper.
 * - Injects Authorization header from Redux store.
 * - On 403 (token expired), attempts one token refresh then retries.
 * - On second failure, logs the user out.
 */
export async function authFetch(path, options = {}) {
  const state = store.getState();
  const token = state.auth.accessToken;

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const res = await fetch(`${API_URL}${path}`, { ...options, headers });

  if (res.status === 403) {
    // Access token expired — try refresh
    const refreshResult = await store.dispatch(refreshAccessToken());
    if (refreshAccessToken.fulfilled.match(refreshResult)) {
      const newToken = store.getState().auth.accessToken;
      const retryHeaders = { ...headers, Authorization: `Bearer ${newToken}` };
      return fetch(`${API_URL}${path}`, { ...options, headers: retryHeaders });
    } else {
      // Refresh failed — log out
      store.dispatch(logoutUser());
      throw new Error('Session expired. Please log in again.');
    }
  }

  return res;
}
